// in dev, this makes Vite inject its client as this module's first dependency,
// so that global constant replacements are installed before any other module
// (including user hooks) evaluates. In build it's inert.
import.meta.hot;




export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25'),
	() => import('./nodes/26'),
	() => import('./nodes/27'),
	() => import('./nodes/28'),
	() => import('./nodes/29'),
	() => import('./nodes/30'),
	() => import('./nodes/31'),
	() => import('./nodes/32'),
	() => import('./nodes/33'),
	() => import('./nodes/34'),
	() => import('./nodes/35'),
	() => import('./nodes/36'),
	() => import('./nodes/37'),
	() => import('./nodes/38'),
	() => import('./nodes/39'),
	() => import('./nodes/40'),
	() => import('./nodes/41'),
	() => import('./nodes/42'),
	() => import('./nodes/43'),
	() => import('./nodes/44'),
	() => import('./nodes/45'),
	() => import('./nodes/46'),
	() => import('./nodes/47'),
	() => import('./nodes/48'),
	() => import('./nodes/49'),
	() => import('./nodes/50'),
	() => import('./nodes/51'),
	() => import('./nodes/52'),
	() => import('./nodes/53'),
	() => import('./nodes/54'),
	() => import('./nodes/55'),
	() => import('./nodes/56'),
	() => import('./nodes/57'),
	() => import('./nodes/58'),
	() => import('./nodes/59'),
	() => import('./nodes/60'),
	() => import('./nodes/61'),
	() => import('./nodes/62'),
	() => import('./nodes/63'),
	() => import('./nodes/64'),
	() => import('./nodes/65')
];

export const server_loads = [];

export const dictionary = {
		"/": [4],
		"/admin": [5,[2]],
		"/admin/analyze": [6,[2]],
		"/admin/analyze/group": [7,[2]],
		"/admin/assessments": [8,[2]],
		"/admin/assessments/import": [10,[2]],
		"/admin/assessments/new": [11,[2]],
		"/admin/assessments/[typeId]": [9,[2]],
		"/admin/assignments": [12,[2]],
		"/admin/debug/crash": [13,[2]],
		"/admin/grades": [14,[2]],
		"/admin/grades/[grade]": [15,[2]],
		"/admin/grants": [16,[2]],
		"/admin/honors": [17,[2]],
		"/admin/interventions": [18,[2]],
		"/admin/interventions/all": [23,[2]],
		"/admin/interventions/group/[groupId]": [24,[2]],
		"/admin/interventions/new": [25,[2]],
		"/admin/interventions/[studentId]": [19,[2]],
		"/admin/interventions/[studentId]/plans/[planId]": [20,[2]],
		"/admin/interventions/[studentId]/plans/[planId]/edit": [21,[2]],
		"/admin/interventions/[studentId]/record": [22,[2]],
		"/admin/privileges": [26,[2]],
		"/admin/privileges/[programId]": [27,[2]],
		"/admin/rosters": [28,[2]],
		"/admin/rosters/[rosterName]": [29,[2]],
		"/admin/sections": [30,[2]],
		"/admin/sections/[sectionId]": [31,[2]],
		"/admin/settings": [32,[2]],
		"/admin/settings/notifications": [33,[2]],
		"/admin/settings/programs": [34,[2]],
		"/admin/settings/programs/new": [36,[2]],
		"/admin/settings/programs/[programId]": [35,[2]],
		"/admin/settings/roles": [37,[2]],
		"/admin/settings/rollover": [38,[2]],
		"/admin/settings/roster-reconciliation": [39,[2]],
		"/admin/students": [40,[2]],
		"/admin/students/[studentId]": [41,[2]],
		"/admin/teachers": [42,[2]],
		"/admin/teachers/[teacherId]": [43,[2]],
		"/debug": [44],
		"/debug/new-intervention": [45],
		"/dev/login": [46],
		"/staff": [47,[3]],
		"/staff/all": [48,[3]],
		"/staff/assignments": [49,[3]],
		"/staff/caseload": [50,[3]],
		"/staff/honors": [51,[3]],
		"/staff/interventions": [52,[3]],
		"/staff/interventions/group/[groupId]": [57,[3]],
		"/staff/interventions/new": [58,[3]],
		"/staff/interventions/[studentId]": [53,[3]],
		"/staff/interventions/[studentId]/plans/[planId]": [54,[3]],
		"/staff/interventions/[studentId]/plans/[planId]/edit": [55,[3]],
		"/staff/interventions/[studentId]/record": [56,[3]],
		"/staff/name-game": [59,[3]],
		"/staff/privileges": [60,[3]],
		"/staff/privileges/[programId]": [61,[3]],
		"/staff/rosters/[rosterName]": [62,[3]],
		"/staff/sections/[sectionId]": [63,[3]],
		"/staff/settings": [64,[3]],
		"/staff/students/[studentId]": [65,[3]]
	};

export const hooks = {
	handleError: (({ error }) => { console.error(error) }),
	
	reroute: (() => {}),
	transport: {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));
export const encoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.encode]));

export const hash = false;

export const decode = (type, value) => decoders[type](value);

export { default as root } from '../root.js';

export const get_error_template = () => import('../shared/error-template.js').then(m => m.default);